import { jsx as _jsx } from "react/jsx-runtime";
import { CopyrightWrap } from "./Copyright.styles";
export const Copyright = ({ text, withMarginRight, previewId, }) => (
// @ts-ignore
_jsx(CopyrightWrap, Object.assign({ "data-preview-id": previewId, "$withMarginRight": withMarginRight, className: "copyright", hasHtml: true }, { children: text })));
